import {
  PERMISSIONS_HIERARCHY,
  type FeaturePermission,
} from '@mint-lib/profile-helpers';

/** Whether `level` grants at least `required`; an unknown level grants nothing. */
export const meetsPermission = (
  level: string | undefined,
  required: FeaturePermission,
): boolean => {
  const index = PERMISSIONS_HIERARCHY.indexOf(level ?? '');
  const requiredIndex = PERMISSIONS_HIERARCHY.indexOf(required);

  return index !== -1 && requiredIndex !== -1 && index >= requiredIndex;
};
